import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

//a new version takes over as soon as it has downloaded, and the page reloads
//once into it. without a connection nothing happens - the app keeps running
//the version it has
serviceWorkerRegistration.register({
  onUpdate: (registration) => registration.waiting?.postMessage({ type: "SKIP_WAITING" }),
});

if ("serviceWorker" in navigator) {
  //the very first install only takes control of the page - nothing new to load.
  //a page opened past the cache (a hard refresh) has no controller either, but
  //a version is already installed, so the next one taking over is a real update
  let hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.getRegistration().then((registration) => {
    if (registration && registration.active) hadController = true;
  }).catch(() => {});
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) {
      hadController = true;
      return;
    }
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
